<template>
  <div>
    <a-row :gutter="[24, 24]">
      <a-col
        :xs="{ span: 24 }"
        :sm="{ span: 24 }"
        :md="{ span: 24 }"
        :xl="{ span: 20, offset: 2 }"
        :lg="{ span: 20, offset: 2 }"
      >
        <span style="font-size: 40px; font-weight: bolder; color: black">
          Search results for "<span
            style="color: white; background-color: #428bca; border-radius: 3px"
          >
            {{ this.$route.query.gene }} </span
          >"</span
        >
        <a-row :gutter="[12, 12]">
          <a-col :span="12" style="margin-top: 5px">
            <a-card size="small" style="height: 400px">
              <span slot="title" style="font-size: 20px">Perturb-Seq </span>
              <searchTable
                style="margin-top: 20px"
                v-bind:perturbedgene="this.$route.query.gene"
            /></a-card>
          </a-col>
          <a-col :span="12" style="margin-top: 5px">
            <a-card style="height: 400px" size="small"
              ><span slot="title" style="font-size: 20px"
                >Bulk Perturbation RNA-Seq</span
              ><searchTableBk
                style="margin-top: 20px"
                v-bind:perturbedgene="this.$route.query.gene"
            /></a-card>
          </a-col>
          <a-col :span="12" style="margin-top: 5px">
            <a-card style="height: 700px" size="small"
              ><span slot="title" style="font-size: 20px"
                >Pan-cancer Analysis
              </span>
              <pancancer v-bind:searchgene="this.$route.query.gene" /> </a-card
          ></a-col>
          <a-col :span="12" style="margin-top: 5px">
            <a-card style="height: 700px" size="small"
              ><div slot="title" style="font-size: 20px">
                Inhibitors
                <a-radio-group
                  v-model="value"
                  @change="onChange"
                  style="margin-left: 15px"
                >
                  <a-radio :value="1"> by Perturb-Seq </a-radio>
                  <a-radio :value="2"> by Bulk perturbation RNA-Seq </a-radio>
                </a-radio-group>
              </div>
              <a-alert banner>
                <span slot="message">
                  <i style="font-weight: bolder">Warnning :</i> The drugs
                  predicted by this tool may not specifically target to
                  {{ this.$route.query.gene }} gene.</span
                ></a-alert
              >
              <drugs v-if="this.value == 1" />
              <bulkDrugs v-if="this.value == 2" /> </a-card
          ></a-col>
        </a-row>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import searchTable from "./search/resultTable/searchSC.vue";
import searchTableBk from "./search/resultTable/searchBK.vue";
import pancancer from "./search/resultTable/panCancer.vue";
import drugs from "./search/resultTable/drugs.vue";
import bulkDrugs from "./search/resultTable/drugsBulk.vue";

import axios from "axios";

export default {
  components: {
    searchTable,
    searchTableBk,
    pancancer,
    drugs,
    bulkDrugs,
  },
  methods: {
    onChange(val) {
      this.value = val.target.value;
    },
  },
  mounted() {
    axios
      .get("http://research.gzsys.org.cn/perturbdb/API/search/bulkseq.php", {
        params: { genename: this.$route.query.gene },
      })
      .then((response) => {
        if (typeof response.data === "object" && response.data !== null) {
          this.bkdata = response.data.length;
          if (response.data.length == 0) {
            this.disabled = true;
          }
        }
      });
    axios
      .get("http://research.gzsys.org.cn/perturbdb/API/search/search1.php", {
        params: { key: this.$route.query.gene },
      })
      .then((response) => {
        if (typeof response.data === "object" && response.data !== null) {
          this.scdata = response.data.length;
        }
      });
  },
  data() {
    return {
      value: 1,
      disabled: false,
      scdata: 0,
      bkdata: 0,
      formLayout: "horizontal",
      customStyle:
        "background: #f7f7f7;border-radius: 4px;margin-bottom: 24px;border: 0;overflow: hidden;font-size:25px;line-height:25px",
    };
  },
};
</script>
<style scpoed>
.h1 {
  font-size: 40px;
  font-weight: bolder;
}
</style>
